<template>
  <div class="step2">
    <div class="cart-list" ref="cartlist">
      <div class="product-check show-on-pad-flex">
        <div class="label-group">
          {{ $t('cart_page.product') }}
        </div>  
      </div>
      <div class="table-header hide-on-pad-flex">
        <div class="td detail">{{ $t('cart_page.info') }}</div>
        <div class="td price">{{ $t('cart_page.price') }}</div>
        <div class="td qty">{{ $t('cart_page.qty') }}</div>
        <div class="td count">{{ $t('cart_page.count') }}</div>
        <div class="td operate"></div>
      </div>
      <div class="table-body" v-if="cars.length>0">
        <div class="tr hide-on-pad-flex" v-for="(item,index) in cars" :key="index+'_pc'">
          <div class="td detail">
            <div class="img-block">
              <img :src="item.photo" alt="product-img">
            </div>
            <div class="detail-content">
              <p>{{ $t('cart_page.name') }}: {{ item.name }}</p>
              <p>{{ item.color }}, {{ item.standard }}{{ item.size }}</p>
              <p class="p-no">{{ $t('cart_page.no') }}: {{ item.no }}</p>
            </div>
          </div>
          <div class="td price">{{ item.price | formatPrice}}</div>
          <div class="td qty">
            {{ item.qty }}
          </div>
          <div class="td count">{{ item.price*item.qty | formatPrice}}</div>
        </div>
        <div class="tr show-on-pad-flex" v-for="(item,index) in cars" :key="index+'_mob'">
          <!-- <div class="label-group">
            <input type="checkbox" :id="index+'_mob_checkbox'" v-model="item.checked"><label class="square" :for="index+'_mob_checkbox'"></label>
          </div>   -->
          <div class="td img"><img :src="item.photo" alt="product-img"></div>
          <div class="td detail">
            <div>
              <p class="p-no">{{ $t('cart_page.no') }}: {{ item.no }}</p>
              <p class="name">{{ item.name }}</p>
            </div>
            <div>
              <span class="color">{{ $t('cart_page.color') }}: {{ item.color }}</span>
              <span class="size">{{ $t('cart_page.size') }}: {{ item.standard }}{{ item.size }}</span>
              <span class="qty">x {{ item.qty }}</span>
            </div>
            <p class="price">{{ item.price | formatPrice}}</p>
          </div>
          <!-- <div class="operate">
            <div class="btn">编辑</div>
            <div class="btn">删除</div>
          </div> -->
        </div>
      </div>
      <div class="no-data" v-else>
        {{ $t('cart_page.empty') }}
      </div>
    </div>

    <div class="card-list ">
      <div class="card ship">
        <div class="card-title">1.{{ $t('cart_page.ship_way') }}</div>
        <div class="card-body">
          <!-- <p class="cart-info">指定配送日期</p>
          <select class="cart-info"  v-show="checkStatus==false">
            <option value="不指定日期">不指定日期</option>
          </select>
          <p class="cart-info">指定配送时间带</p>
          <select class="cart-info"  v-show="checkStatus==false">
            <option value="不指定时间">不指定时间</option>
          </select> -->
          <div class="group-info-item flex-s">
            <div class="item-title">{{ $t('cart_page.ship_date') }}: </div>
            <div class="item-content">
              <div class="read-only-input flex-x" v-show="checkStatus==true">{{ formatShipDate(formdata.shipDate) }}</div>
              <select class="cart-info" :class="{ 'mb-0':formdata.shipDate!='1' }" v-model="formdata.shipDate" v-show="checkStatus==false">
                <option value="0">{{ $t('cart_page.ship_date1') }}</option>
                <option value="1">{{ $t('cart_page.ship_date2') }}</option>
              </select>
              <el-date-picker
                v-show="formdata.shipDate=='1'"
                :disabled="checkStatus==true"
                v-model="formdata.date"
                type="date"
                :placeholder="$t('cart_page.choose_date')">
              </el-date-picker>
            </div>
          </div>
          <div class="group-info-item flex-s">
            <div class="item-title">{{ $t('cart_page.ship_time') }}: </div>
            <div class="item-content">
              <div class="read-only-input flex-x" v-show="checkStatus==true">{{ formatShipTime(formdata.shipTime) }}</div>
              <select class="cart-info" v-model="formdata.shipTime" v-show="checkStatus==false">
                <option value="0">{{ $t('cart_page.ship_time1') }}</option>
                <option value="1">{{ $t('cart_page.ship_time2') }}</option>
                <option value="2">{{ $t('cart_page.ship_time3') }}</option>
                <option value="3">{{ $t('cart_page.ship_time4') }}</option>
              </select>
            </div>
          </div>
          <!-- <div class="group-info-item flex-s">
            <div class="item-title">运送方式: </div>
            <div class="item-content">
              <div class="read-only-input flex-x" v-show="checkStatus==true">{{ formdata.toteType | formatToteType }}</div>
              <select class="cart-info" v-model="formdata.toteType" v-show="checkStatus==false">
                <option value="1">自取</option>
                <option value="2">宅配</option>
              </select>
            </div>
          </div> -->
        </div>
      </div>
      <div class="card">
        <div class="card-title">{{ $t('cart_page.price_title') }}</div>
        <div class="card-body">
          <p class="cart-info">{{ $t('cart_page.count') }}<span>{{ totalCount | formatPrice }}</span></p>
          <p class="cart-info">{{ $t('cart_page.ship_fee') }}<span>{{ shipPrice | formatPrice }}</span></p>
          <p class="cart-info coupon">{{ $t('cart_page.coupon') }}<span>{{ couponPrice }}</span></p>
          <p class="cart-info total">{{ $t('cart_page.total') }}<span>{{  totalPrice | formatPrice }}</span></p>
        </div>
      </div>
    </div>

    <div class="card-list">
      <div class="card">
        <div class="card-title">2.{{ $t('cart_page.recipient') }}</div>
            <div class="card-body">
              <div class="group-info-item flex-x addr-type">
                <!-- <div class="item-title has-black-radio">配送到资料地址: </div> -->
                <div class="label-group">
                  <input type="radio" id="useAddr" name="addrType" value="0" v-model="shipType" :disabled="checkStatus==true"><label for="useAddr">{{ $t('cart_page.recipient_type1') }}</label>
                </div>  
                <div class="label-group">
                  <input type="radio" id="otherAddr" name="addrType" value="1" v-model="shipType" :disabled="checkStatus==true"><label for="otherAddr">{{ $t('cart_page.recipient_type2') }}</label>
                </div>  
              </div>
              <div class="group-info-item flex-s">
                <div class="item-title">{{ $t('cart_page.user_name') }}: </div>
                <div class="item-content">
                  <!-- <div class="read-only-input flex-x" v-show="checkStatus==true">{{ 123123 }}</div> -->
                  <input type="text" :placeholder="$t('cart_page.user_name')" class="flex-x" v-model="formdata.username" :disabled="checkStatus==true">
                </div>
              </div>
              <div class="group-info-item flex-s">
                <div class="item-title">{{ $t('cart_page.user_tel') }}: </div>
                <div class="item-content">
                  <!-- <div class="read-only-input flex-x" v-show="checkStatus==true">{{ 1231233 }}</div> -->
                  <input type="text" :placeholder="$t('cart_page.user_tel')" class="flex-x" v-model="formdata.phone" :disabled="checkStatus==true">
                </div>
              </div>
              <div class="group-info-item flex-s">
                <div class="item-title">{{ $t('cart_page.user_mobile') }}: </div>
                <div class="item-content">
                  <!-- <div class="read-only-input flex-x" v-show="checkStatus==true">{{ 123123 }}</div> -->
                  <input type="text" :placeholder="$t('cart_page.user_tel')" class="flex-x" v-model="formdata.mobile" :disabled="checkStatus==true">
                </div>
              </div>
              <div class="group-info-item mt-10 flex-x">
                <div class="item-title">{{ $t('cart_page.user_addr') }}: </div>
                <div class="item-content">

                  <!-- <input type="text" placeholder="邮递区号" class="flex-s" v-model="formdata.zip" :disabled="checkStatus==true">
                  <input type="text" placeholder="省份" class="flex-s" v-model="formdata.province" :disabled="checkStatus==true">
                  <input type="text" placeholder="城市" class="flex-s" v-model="formdata.city"  :disabled="checkStatus==true">
                  <input type="text" placeholder="行政区" class="flex-s" v-model="formdata.area"  :disabled="checkStatus==true">
                  <input type="text" placeholder="完整地址" class="flex-x" v-model="formdata.addr"  :disabled="checkStatus==true"> -->

                  <select v-model="formdata.province" :disabled="checkStatus==true" class="flex-s">
                    <option value="">{{ $t('cart_page.choose_province') }}</option>
                    <option :value="province.code" v-for="province in chinacode" :key="province.code">{{province.name}}</option>
                  </select>
                  <select v-model="formdata.city" :disabled="checkStatus==true" class="flex-s">
                    <option value="">{{ $t('cart_page.choose_city') }}</option>
                    <option :value="city.code" v-for="city in getCitySelect" :key="city.code">{{city.name}}</option>
                  </select>
                  <select v-model="formdata.area" :disabled="checkStatus==true" class="flex-s" @change="handleAreaChange">
                    <option value="">{{ $t('cart_page.choose_area') }}</option>
                    <option :value="area.code" v-for="area in getAreaSelect" :key="area.code">{{area.name}}</option>
                  </select>
                  <input type="text" :placeholder="$t('cart_page.user_zip')" class="flex-s" v-model="formdata.zip"  :disabled="checkStatus==true">
                  <input type="text" :placeholder="$t('cart_page.user_all_addr')" class="flex-x" style="" v-model="formdata.addr"  :disabled="checkStatus==true">
                  <div class="flex-s"></div>
                </div>
              </div>
              <div class="group-info-item mt-10 flex-x">
                <div class="item-title">{{ $t('cart_page.remark') }}: </div>
                <div class="item-content">
                  <!-- <div class="read-only-input flex-x min-h-8" v-show="checkStatus==true">{{ formdata.remark | formatEmpty }}</div> -->
                  <!-- <input type="text" placeholder="备注" class="flex-x" v-show="checkStatus==false"> -->
                  <textarea :placeholder="$t('cart_page.remark')" class="flex-x" :disabled="checkStatus==true" v-model="formdata.remark"></textarea>
                </div>
              </div>
            </div>
      </div>
    </div>

    <div class="btns">
      <div class="btn btn-grey" @click="handelBack">{{ checkStatus ? $t('cart_page.back') : $t('cart_page.back_to_cart') }}</div>
      <div class="btn btn-orange" @click="handleNext">{{ checkStatus ? $t('cart_page.checkout_type') : $t('cart_page.submit') }}</div>
    </div>

  </div>
</template>

<script>
import { Loading } from 'element-ui';
import { mapState } from 'vuex'
import chinacode from '../mock/chinacode.json';

  let mountData = true;
  export default {
    name: 'CartStep2',
    components: {
      
    },
    props: {
      cars: {
        type: Array,
        default: () => []
      },
      totalCount: {
        type: Number,
        default: 0
      },
      shipPrice: {
        type: Number,
        default: 0
      },
      couponPrice: {
        type: String,
        default: 0
      },
      totalPrice: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        pageSize: 20,
        checkStatus: false,
        formdata: {
          date: '',
          shipDate: '0',
          shipTime: '0',
          // toteType: '1',
          username: '',
          phone: '',
          mobile: '',
          zip: '',
          province: '',
          city: '',
          area: '',
          addr: '',
          remark: '',
        },
        chinacode,
        shipType: 0, // 收件人地址用预设(0)的还是用户自己填写(1)
      }
    },
    filters: {
      formatPrice(value) {
        let priceText = 0;
        if(value && value!='undefined') priceText = value;
        const priceArr = String(priceText).split('');
        let price = '';
        priceArr.forEach((item, index) => {
            if (index >= 3 && index % 3 == 0) {
                price = priceArr[priceArr.length - index - 1] + ',' + price;
            } else {
                price = priceArr[priceArr.length - index - 1] + price;
            }
        })
        return '$'+price;
      },
      // formatToteType(value) {
      //   switch (value) {
      //     case '1':
      //       return '自取'
      //       break;
      //     case '2':
      //       return '宅配'
      //       break;
      //   }
      // }
    },
    computed: {
      ...mapState(['userInfo']),
      getCitySelect() {
        return this.getCitySelectData();
      },
      getAreaSelect() {
        return this.getAreaSelectData();
      },
    },
    watch: {
      shipType(newD,oldD) {
        console.log('ship type');
        const formdata = { ...this.formdata };
        if(newD == 0) {
          // 预设的
          mountData=true;
          formdata.username = this.userInfo.user.username;
          formdata.phone = this.userInfo.user.phone;
          formdata.mobile = this.userInfo.user.mobile;
          formdata.zip = this.userInfo.user.zip;
          formdata.province = this.userInfo.user.province;
          formdata.city = this.userInfo.user.city;
          formdata.area = this.userInfo.user.area;
          formdata.addr = this.userInfo.user.area + this.userInfo.user.ship_addr1;
          
        }else{
          // 自己填写
          formdata.username = '';
          formdata.phone = '';
          formdata.mobile = '';
          formdata.zip = '';
          formdata.province = '';
          formdata.city = '';
          formdata.area = '';
          formdata.addr = '';
        }
        this.formdata = formdata;
        setTimeout(() => {
          mountData=false;
        }, 100);
      }
    },
    created() {
      
    },
    mounted() {
      let formdata = { ...this.formdata };
      formdata.username = this.userInfo.user.username;
      formdata.phone = this.userInfo.user.phone;
      formdata.mobile = this.userInfo.user.mobile;
      formdata.zip = this.userInfo.user.zip;
      formdata.province = this.userInfo.user.province;
      formdata.city = this.userInfo.user.city;
      formdata.area = this.userInfo.user.area;
      formdata.addr = this.userInfo.user.area + this.userInfo.user.ship_addr1;
      this.formdata = formdata;
      // 加这个的原因是因为我在改变地址的选择器时会清掉该栏位之下的值
      // 例如province改变了area和city会被清空
      // 但是批量赋值的时候不应该做这件事情
      // 因此用这个变数来判断是否是为批量赋值
      setTimeout(() => {
        mountData = false;
      }, 1000);
    },
    methods: {
      formatEmpty(value) {
        if(!value) return this.$t('format.empty');
        return value;
      },
      formatShipDate(value) {
        switch (value) {
          case '0':
            return this.$t('cart_page.ship_date1');
            break;
          case '1':
            return this.$t('cart_page.ship_date2');
            break;
        }
      },
      formatShipTime(value) {
        switch (value) {
          case '0':
            return this.$t('cart_page.ship_time1');
            break;
          case '1':
            return this.$t('cart_page.ship_time2');
            break;
          case '2':
            return this.$t('cart_page.ship_time3');
            break;
          case '3':
            return this.$t('cart_page.ship_time4');
            break;
        }
      },
      handleChange(val) {
        console.log('qty change to ',val);
      },
      handleCheckout() {
        
      },
      handelBack() {
        if(this.checkStatus) {
          this.checkStatus = false;
        }else{
          this.$emit('next', 'cart');
        }
      },
      handleNext() {
        if(this.checkStatus) {
          this.checkStatus = false;
          this.$emit('next', 'pay');
        }else{
          this.checkStatus = true;
        }
      },
      getCitySelectData(i='') {
        // console.log('getAreaSelectData',i);
        // 省份变化了这样就要把area和city清空
        if(!mountData) {
          this.formdata[`area${i}`] = '';
          this.formdata[`city${i}`] = '';
        }
        if(this.formdata[`province${i}`]) {
          const cityData = this.chinacode.filter(item => item.code==this.formdata[`province${i}`])[0].children;
          return cityData;
        }else{
          return [];
        }
      },
      getAreaSelectData(i='') {
        // console.log('getCitySelectData',i);
        // 市变化了这样就要把city清空
        if(!mountData) {
          this.formdata[`area${i}`] = '';
        }
        if(this.formdata[`city${i}`]) {
          const areaData = this.chinacode.filter(item => item.code==this.formdata[`province${i}`])[0].children.filter(item => item.code==this.formdata[`city${i}`])[0].children;
          return areaData;
        }else{
          return [];
        }
      },
      handleAreaChange(e) {
        const zip = e.target.value;
        this.$set(this.formdata,'zip',zip);
      },
    }
  }
</script>

<style lang="less" scoped>
.step2 {
  .cart-list {
    width: 100%;
    // text-align: center;
    margin-bottom: 30px;
    border: 1px solid #F0F0F0;
    padding: 0 20px;
    @media (max-width: 992px) {
      border: unset;
    }
    .product-check {
      padding: 10px 0;
      padding-left: 16px;
      background: #F7F8FA;
      margin-left: -16px;
      margin-right: -16px;
    }
    .table-header {
      // background: #F0F0F0;
      padding: 15px 15px;
      display: flex;
      margin-bottom: 10px;
      border-bottom: 1px solid #F0F0F0;
    }
    .table-body {
      .tr {
        display: flex;
        border-bottom: 1px solid #E6E6E6;
        padding: 20px 0;
        &:nth-last-child(2) {
          border-bottom: unset;
        }
        &.show-on-pad-flex {
          // padding-left: 30px;
          position: relative;
          .label-group {
            position: absolute;
            left: 0px;
          }
        }
      }
      .detail {
        text-align: left;
      }
    }
    // .index {
    //   flex: 0 0 13%;
    // }
    // .img {
    //   flex: 0 0 20%;
    //   margin: 0 15px;
    //   position: relative;
    //   padding-top: calc(20%/240*300);
    //   &.withoutPT {
    //     padding-top: 0;
    //   }
    //   img {
    //     width: 100%;
    //     height: 100%;
    //     object-fit: cover;
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     display: block;
    //   }
    // }
    // .detail {
    //   flex: 0 0 30%;
    //   position: relative;
    //   p {
    //     margin-bottom: 10px;
    //   }
    //   .p-no {
    //     position: absolute;
    //     bottom: 0;
    //     left: 0;
    //   }
    // }
    // .qty {
    //   flex: 0 0 18%;
    // }
    // .price {
    //   flex: 0 0 19%;
    // }
    .img {
      width: 100px;
      height: 100px;
      overflow: hidden;
      border-radius: 8px;
      margin-right: 10px;
      img {
        width: 100%;
      }
    }
    .detail {
      flex: 0 0 42.5%;
      display: flex;
      @media (max-width: 992px) {
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        .name {
          font-size: 1.2rem;
          font-weight: 400;
        }
        .p-no {
          font-size: 0.8rem;
          margin-bottom: 5px;
          font-weight: 300;
        }
        .color {
          font-size: 0.8rem;
          margin-right: 12px;
        }
        .size {
          font-size: 0.8rem;
          margin-right: 12px;
        }
        .qty {
          font-size: 0.8rem;
        }
        .price {
          color: #EC4F00;
          font-size: 1.2rem;
          font-weight: 500;
        }
      }
      .img-block {
        width: 120px;
        height: 150px;
        margin-right: 20px;
        position: relative;
        overflow: hidden;
        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
        }
      }
      .detail-content {
        flex: 1;
        height: 100%;
        position: relative;
        padding-right: 20px;
        p {
          margin-bottom: 10px;
        }
        .p-no {
          position: absolute;
          bottom: 0;
          left: 0;
          font-size: 0.8rem;
        }
      }
    }
    .price {
      flex: 0 0 22.5%;
    }
    .qty {
      flex: 0 0 17.5%;
      /deep/ .el-input-number {
        width: 80px;
        .el-input-number__decrease,.el-input-number__increase {
          width: 20px;
          border: 1px solid #F0F0F0;
          background: #F0F0F0;
          border-radius: 0;
        }
        .el-input__inner {
          padding: 0;
          border: 1px solid #F0F0F0;
          border-radius: 0;
        }
      }
    }
    .count {
      flex: 0 0 17.5%;
      text-align: right;
    }
    .operate {
      flex: 0 0 10%;
      /deep/ .cloud-icon {
        margin-right: 0;
        margin-left: auto;
        svg {
          fill: #656565;
        }
      }
      
      @media (max-width: 992px) {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        margin-left: 10px;
        .btn {
          cursor: pointer;
          box-shadow: unset;
          color: #707070;
          border: 1px solid #707070;
          padding: 8px;
          width: 100%;
          margin-top: 10px;
          &:nth-child(1) {
            margin-top: 0;
          }
        }
      }
    }
  }

  .card-list {
    display: flex;
    margin-bottom: 0px !important;
    @media (max-width: 992px) {
      padding: 0 20px;
      flex-direction: column-reverse;
    }
  }
  .card {
    &.coupon {
      align-self: baseline;
      .group-item {
        display: flex;
        width: 100%;
        padding: 40px;
        background: #FAFAFA;
        .btn {
          width: 120px;
        }
        input {
          flex: 1;
          margin-right: 20px;
          border: 1px solid #E6E6E6;
        }
      }
    }
    &.show-on-pad {
      margin-left: 20px !important;
      margin-right: 20px;
      padding-bottom: 0;
      .card-foot {
        background: white;
        border-top: 0;
        margin-left: -15px;
        margin-right: -15px;
      }
    }
    &.ship {
      .card-body {
        flex-direction: column;
        .flex-s {
          width: 30%;
          @media (max-width: 992px) {
            width: auto;
          }
        }
        .group-info-item {
          select {

          }
        }
      }
    }
    
  }
  .addr-type {
    display: flex;
    @media (max-width: 992px) {
      flex-direction: column;
      .label-group {
        margin-bottom: 10px;
      }
    }
  }
}
</style>